import { z } from "zod/v4";
import { matchStatusSchema, winningSideSchema } from "./shared";

export const matchSchema = z.object({
	id: z.string().uuid(),
	game_id: z.string().uuid(),
	team1_player_ids: z.array(z.string().uuid()),
	team2_player_ids: z.array(z.string().uuid()),
	winning_side: winningSideSchema.nullable().catch(null),
	status: matchStatusSchema,
	started_at: z.coerce.date(),
	ended_at: z.coerce.date().nullable().catch(null),
});

export const createMatchSchema = matchSchema.omit({
	id: true,
	started_at: true,
	ended_at: true,
});

export const updateMatchSchema = createMatchSchema.partial();
